import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class UnsubscribeEmailAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'unsubscribe-email';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'unsubscribes/emails';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'updatedAt',
      'email',
      'emailIdentifierUuid',
      'emailCampaignUuid',
      'senderUserUuid',
      'sendgridApiKey',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return [
    ];
  }

}

export default UnsubscribeEmailAppResource;
